import React, { useState } from "react";
import {
  tableImg,
  tableImg2,
  messageIconBlack,
} from "../../../constant/imagePath";
import { AdminTable } from "../../../stories/AdminTable/AdminTable";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";

import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import classes from "./UserComplaints.module.css";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory, useLocation, Link } from "react-router-dom";

// modals import
import MessageDetailsModal from "../../../components/Modals/Admin/MessageDetailsModal/MessageDetailsModal";
import UserDetailModal from "../../../components/Modals/Admin/UserDetailModal/UserDetailModal";
import dropdownClasses from "../../../stories/DropDown/DropDown.module.css";
import { TableCell, TableRow } from "@mui/material";
import { Button } from "../../../stories/Button/Button";
import Layout from "../Layout/Layout";

const UserComplaints = () => {
  const [isUserDetails, setIsUserDetails] = useState(false);
  const [isOpenChat, setIsOpenChat] = useState(false);
  // DropDown States
  const [date, setDate] = useState();
  const [status, setStatus] = useState();
  const [rating, setRating] = useState();
  const [userType, setUserType] = useState();
  const [location1, setLocation1] = useState();

  const dummy = [
    {
      image: tableImg,
      name: "Ann Johnson",
      role: "student",
      date: "Jan 16, 2021",
      lastCancel: "medical emergency",
      rating: "5.0",
      status: "pending",
    },
    {
      image: tableImg2,
      name: "Sarika Bhimre",
      role: "student",
      date: "Jan 16, 2021",
      lastCancel: "Unspecified",
      rating: "5.0",
      status: "pending",
    },
    {
      image: tableImg2,
      name: "Kate Smith",
      role: "student",
      date: "Jan 16, 2021",
      lastCancel: "medical emergency",
      rating: "4.7",
      status: "solved",
    },
    {
      image: tableImg,
      name: "John White",
      role: "coach",
      date: "Jan 16, 2021",
      lastCancel: "Weather",
      rating: "3.9",
      status: "solved",
      chat: messageIconBlack,
    },
    {
      image: tableImg2,
      name: "Peter Parker",
      role: "student",
      date: "Jan 16, 2021",
      lastCancel: "Unspecified",
      rating: "4.5",
      status: "solved",
      chat: messageIconBlack,
    },
    {
      image: tableImg2,
      name: "Jon Snow",
      role: "coach",
      date: "Jan 16, 2021",
      lastCancel: "Weather",
      rating: "5.0",
      status: "solved",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Anthony Kiedis",
      role: "coach",
      date: "Jan 16, 2021",
      lastCancel: "Unspecified",
      rating: "4.9",
      status: "solved",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Alex Turner",
      role: "coach",
      date: "Jan 16, 2021",
      lastCancel: "Unspecified",
      rating: "4.0",
      status: "solved",
      chat: messageIconBlack,
    },
  ];
  const tableHeadings = [
    { title: "User Name" },
    { title: "User type" },
    { title: "Date" },
    { title: "Reason" },
    { title: "Rating", filter: true },
    { title: "Status" },
  ];

  const statusOptions = [{ label: "All", value: "all" }];
  const ratingOptions = [{ label: "All", value: "all" }];
  const userTypeOptions = [{ label: "All", value: "all" }];

  return (
    <>
      <style>{`.${dropdownClasses.reactSelect} > div {
        z-index: 3;
      }
    }`}</style>
      <div className={classes.AdminTableMain}>
        {/* Layout */}
        <Layout location1={location1} />

        <div className={classes.tableMain}>
          <Container fluid className={classes.container}>
            <h3
              className={classes.marginBlock24}
              style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
            >
              Complaints
            </h3>
            <Row className={`gx-1 ${classes.mb24}`}>
              <Col md={4}>
                <InputWithSearchIcon />
              </Col>
              <Col md={2}>
                <DropDown state={date} setter={setDate} placeholder={"Date"} />
              </Col>
              <Col md={2}>
                <DropDown
                  state={status}
                  setter={setStatus}
                  placeholder={"Status"}
                  options={statusOptions}
                />
              </Col>
              <Col md={2}>
                <DropDown
                  state={rating}
                  setter={setRating}
                  placeholder={"Rating"}
                  options={ratingOptions}
                />
              </Col>
              <Col md={2}>
                <DropDown
                  state={userType}
                  setter={setUserType}
                  placeholder={"User Type"}
                  options={userTypeOptions}
                />
              </Col>
            </Row>
            <div className={classes.overflowScroll630}>
              <AdminTable
                headings={tableHeadings}
                renderDataWithElement={dummy?.map((item) => (
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <div className={classes.tableImgDiv}>
                        <>
                          {item?.role === "student" && (
                            <div
                              className={classes.innerImgCont}
                              onClick={() => setIsUserDetails(true)}
                            >
                              <img src={item?.image} alt="tableImg" />
                            </div>
                          )}
                          {item?.role === "coach" && (
                            <div
                              className={classes.innerImgCont}
                              onClick={() => setIsUserDetails(true)}
                            >
                              <img src={item?.image} alt="tableImg" />
                            </div>
                          )}
                        </>
                        <h6
                          style={{
                            ...Fonts.b3,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {" "}
                          {item?.name}
                        </h6>
                      </div>
                    </TableCell>

                    <TableCell>
                      <p
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfNero,
                          textTransform: "capitalize",
                        }}
                      >
                        {item?.role}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {item?.date}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p
                        style={{
                          ...Fonts.p1,
                          color:
                            item?.lastCancel == "Unspecified"
                              ? Colors.neutralShadesOfPinkSwan
                              : item?.lastCancel !== "" &&
                              Colors.neutralShadesOfNero,
                          textTransform: "capitalize",
                        }}
                      >
                        {item?.lastCancel}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {item?.rating}
                      </p>
                    </TableCell>
                    <TableCell>
                      <div className={classes.statusAndChat}>
                        <div className={classes.status}>
                          <p
                            style={{
                              ...Fonts.p1,
                              color:
                                item?.status == "pending"
                                  ? Colors.neutralShadesOfPinkSwan
                                  : "#37A512",
                            }}
                          >
                            {(item?.status == "pending" && "Pending") ||
                              (item?.status == "solved" && "Solved")}
                          </p>
                        </div>

                        {item?.status == "pending" ? (
                          <Button
                            icon={messageIconBlack}
                            size="Small"
                            onClick={() => setIsOpenChat(true)}
                          />
                        ) : (
                          <Button
                            icon={messageIconBlack}
                            size="Small"
                            onClick={() => setIsOpenChat(true)}
                          />
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              />
            </div>
          </Container>
        </div>
      </div>
      {/* <UnBanModal show={show} setShow={setShow} /> */}
      {/* <BanExplanationModal show={show1} setShow={setShow1} /> */}
      <MessageDetailsModal show={isOpenChat} setShow={setIsOpenChat} />
      <UserDetailModal show={isUserDetails} setShow={setIsUserDetails} />
      {/* <ComplaintsModalCoach show={show4} setShow={setShow4} /> */}
      {/* <ComplaintsModalStudent show={show5} setShow={setShow5} /> */}
    </>
  );
};

export default UserComplaints;
